import { Admin } from "@/models/admin";

export class TicketMessageAttention {
	id:number;
	messageId:number;
	adminId:number;
	read:boolean;
	admin?:Admin;

	constructor(data:any) {
		this.id = data.id;
		this.messageId = data.messageId;
		this.adminId = data.adminId;
		this.read = data.read;
		if (data.admin) {
			this.admin = new Admin(data.admin);
		}
	}
}